// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const MoreOverflow = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <circle cx={3} cy={9} r={1.5} stroke="currentColor" />
    <circle cx={9} cy={9} r={1.5} stroke="currentColor" />
    <circle cx={15} cy={9} r={1.5} stroke="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(MoreOverflow);
export default ForwardRef;
